import { workerConstants } from "../_constants";
import { workerService } from "../_services";
import { alertActions, loaderActions } from "./";
import { history } from "../_helpers";
export const workerActions = {
  login,
  logout,
  addWorker,
  updatePassword,
  uploadImage,
  disableWorker,
  deleteWorker,
  updateWorker,
  getAllWorker,
  getWorkerList,
};
function login(data) {
  return (dispatch) => {
    dispatch(request({ data }));
    workerService.login(data).then(
      (worker) => {
        dispatch(success(worker));
        history.push({ pathname: "#/app/dashboard" });
        window.location.reload();
      },
      (error) => {
        console.log("errorerror ", error);
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      },
    );
  };

  function request(worker) {
    return { type: workerConstants.LOGIN_REQUEST, worker };
  }
  function success(worker) {
    return { type: workerConstants.LOGIN_SUCCESS, worker };
  }
  function failure(error) {
    return { type: workerConstants.LOGIN_FAILURE, error };
  }
}
function logout() {
  workerService.logout();
  return { type: workerConstants.LOGOUT };
}
function getWorkerList(data) {
  return (dispatch) => {
    dispatch(request());
    workerService.getWorkerList(data).then(
      (workers) => dispatch(success(workers)),
      (error) => {
        dispatch(alertActions.error(error));
        dispatch(failure(error));
      },
    );
  };
  function request() {
    return { type: workerConstants.GETALL_REQUEST };
  }
  function success(workers) {
    return { type: workerConstants.GETALL_SUCCESS, workers };
  }
  function failure(error) {
    return { type: workerConstants.GETALL_FAILURE, error };
  }
}

function updatePassword(data) {
  let reqData = {
    keyWord: "",
    pageNo: 1,
    roll_id: 2,
    sortOrder: "1",
    size: 10,
  };
  return (dispatch) => {
    dispatch(request());
    workerService.updatePassword(data).then(
      (users) => {
        // toast("Password Updated successfully.")
        dispatch(alertActions.success("Password Updated successfully."));
        dispatch(success(users));
        dispatch(workerActions.getWorkerList(reqData));
      },
      (error) => {
        dispatch(alertActions.error(error));
        dispatch(failure(error));
      },
    );
  };
  function request() {
    return { type: workerConstants.UPDATE_WORKER_PASSWORD_REQUEST };
  }
  function success(users) {
    return { type: workerConstants.UPDATE_WORKER_PASSWORD_SUCCESS, users };
  }
  function failure(error) {
    return { type: workerConstants.UPDATE_WORKER_PASSWORD_FAILURE, error };
  }
}

function getAllWorker(data) {
  return (dispatch) => {
    dispatch(request());
    workerService.getAllWorker(data).then(
      (workers) => {
        //console.log("workers  ",workers);
        let returnResppnse = workers.getAllWorker
          ? workers.getAllWorker.map((worker) => ({
            value: worker.id,
            label: worker.firstName + " " + worker.lastName,
          }))
          : [];
        let newRespnse = { ...workers, getAllWorker: returnResppnse };
        dispatch(success(newRespnse));
      },
      (error) => {
        dispatch(alertActions.error(error));
        dispatch(failure(error));
      },
    );
  };
  function request() {
    return { type: workerConstants.GET_ALL_WORKER_REQUEST };
  }
  function success(workers) {
    return { type: workerConstants.GET_ALL_WORKER_SUCCESS, workers };
  }
  function failure(error) {
    return { type: workerConstants.GET_ALL_WORKER_FAILURE, error };
  }
}
function addWorker(data) {
  let tempdata = {
    keyWord: "",
    pageNo: 1,
    size: 10,
    roll_id: 2,
  };
  return (dispatch) => {
    dispatch(request());
    workerService.addWorker(data).then(
      (workers) => {
        dispatch(success(workers));
        dispatch(this.getWorkerList(tempdata));
      },
      (error) => {
        dispatch(alertActions.error(error));
        dispatch(failure(error));
      },
    );
  };
  function request() {
    return { type: workerConstants.ADD_RESTAURANT_WORKER_REQUEST };
  }
  function success(workers) {
    return { type: workerConstants.ADD_RESTAURANT_WORKER_SUCCESS, workers };
  }
  function failure(error) {
    return { type: workerConstants.ADD_RESTAURANT_WORKER_FAILURE, error };
  }
}
function updateWorker(data) {
  let tempdata = {
    keyWord: "",
    pageNo: 1,
    size: 10,
    roll_id: 2,
  };
  return (dispatch) => {
    dispatch(request());
    workerService.updateWorker(data).then(
      (workers) => {
        dispatch(success(workers));
        dispatch(this.getWorkerList(tempdata));
      },
      (error) => {
        dispatch(alertActions.error(error));
        dispatch(failure(error));
      },
    );
  };
  function request() {
    return { type: workerConstants.ADD_RESTAURANT_WORKER_REQUEST };
  }
  function success(workers) {
    return { type: workerConstants.ADD_RESTAURANT_WORKER_SUCCESS, workers };
  }
  function failure(error) {
    return { type: workerConstants.ADD_RESTAURANT_WORKER_FAILURE, error };
  }
}
function disableWorker(data) {
  const { value } = data;
  // let tempdata = {
  //   keyWord: "",
  //   pageNo: 1,
  //   size: 10,
  // };
  return (dispatch) => {
    dispatch(loaderActions.startLoader());
    dispatch(request());
    workerService.disableWorker(data).then(
      (workers) => {
        dispatch(
          alertActions.success(
            `User ${value ? "enabled" : "disabled"} successfully`,
          ),
        );
        // dispatch(success(workers));
        // dispatch(this.getWorkerList(tempdata));
        dispatch(loaderActions.stopLoader());
      },
      (error) => {
        dispatch(alertActions.error(error));
        dispatch(failure(error));
        dispatch(loaderActions.stopLoader());
      },
    );
  };
  function request() {
    return { type: workerConstants.ADD_RESTAURANT_WORKER_REQUEST };
  }
  // function success(workers) {
  //   return { type: workerConstants.ADD_RESTAURANT_WORKER_SUCCESS, workers };
  // }
  function failure(error) {
    return { type: workerConstants.ADD_RESTAURANT_WORKER_FAILURE, error };
  }
}
function deleteWorker(data) {
  let tempdata = {
    keyWord: "",
    pageNo: 1,
    size: 10,
  };
  let maintempdata = {
    id: data.id,
  };
  return (dispatch) => {
    dispatch(request());
    workerService.deleteWorker(maintempdata).then(
      (workers) => {
        dispatch(success(workers));
        dispatch(this.getWorkerList(tempdata));
      },
      (error) => {
        dispatch(alertActions.error(error));
        dispatch(failure(error));
      },
    );
  };
  function request() {
    return { type: workerConstants.ADD_RESTAURANT_WORKER_REQUEST };
  }
  function success(workers) {
    return { type: workerConstants.ADD_RESTAURANT_WORKER_SUCCESS, workers };
  }
  function failure(error) {
    return { type: workerConstants.ADD_RESTAURANT_WORKER_FAILURE, error };
  }
}
function uploadImage(data) {
  return (dispatch) => {
    workerService.uploadImage(data).then(
      (uploadImage) => {
        dispatch(success(uploadImage));
      },
      (error) => {
        dispatch(alertActions.error(error));
        dispatch(failure(error));
      },
    );
  };
  function success(uploadImage) {
    return { type: workerConstants.FILE_UPLOAD_STATUS_SUCCESS, uploadImage };
  }
  function failure(error) {
    return { type: workerConstants.FILE_UPLOAD_STATUS_FAILURE, error };
  }
}
